import isEmpty from "is-empty";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { BaseInputDiscount } from "..";
import { useCart, useSession } from "@hooks";

type InputDiscountProps = {
  placeholder: string;
  btnSubmitText?: string;
  onSuccess: (str: string, code?: string) => void;
  onError: (str: string, code?: string) => void;
};

const languagesVarsCodes = [
  "LANG_neobooking_discount_successfully_applied", //Réduction appliquée !
  "LANG_neobooking_discount_applying_in_progress", //Application de la réduction en cours
];

const InputDiscount: React.FC<InputDiscountProps> = ({
  placeholder,
  btnSubmitText = "OK",
  onSuccess,
  onError,
}) => {
  /* Hooks */
  const { cart, addDiscountCode } = useCart();
  const { getLanguageVarValue } = useSession();

  /* State */
  const code: string | null =
    cart && cart.reservations && cart.reservations?.length!! > 0
      ? cart.reservations[0]!!.discountCode!!
      : "";
  const [discountCode, setDiscountCode] = useState<string>(code ? code : "");
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  useEffect(() => {
    const code: string | null =
      cart && cart.reservations && cart.reservations?.length!! > 0
        ? cart.reservations[0]!!.discountCode!!
        : "";
    setDiscountCode(code ? code : "");
  }, [cart]);

  const handleSubmitDiscountCode = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    const toastAdd = toast.loading(
      `${getLanguageVarValue(
        "LANG_neobooking_discount_applying_in_progress"
      )}...`
    );
    if (!isEmpty(discountCode)) {
      addDiscountCode(discountCode, (err) => {
        if (err) {
          toast.error(err.message, {
            id: toastAdd,
          });
          onError(err.message, discountCode);
          onSuccess("");
        } else {
          toast.success(
            getLanguageVarValue(
              "LANG_neobooking_discount_successfully_applied"
            ),
            {
              id: toastAdd,
            }
          );
          onError("", discountCode);
          onSuccess(
            getLanguageVarValue(
              "LANG_neobooking_discount_successfully_applied"
            ),
            discountCode
          );
        }
        setIsSubmitting(false);
      });
    }
  };

  return (
    <BaseInputDiscount
      value={discountCode}
      setValue={setDiscountCode}
      onSubmit={handleSubmitDiscountCode}
      isSubmitting={isSubmitting}
      placeholder={placeholder}
      btnSubmitText={btnSubmitText}
      onFormChange={() => onError("")}
    />
  );
};

InputDiscount.propTypes = {
  //
};

export default InputDiscount;
